// extracted by mini-css-extract-plugin
module.exports = {"tssImg":"partnerContent-module--tssImg--26VUz","flex":"partnerContent-module--flex--227Lm","partnersHeadingYaml":"partnerContent-module--partnersHeadingYaml--4U--1"};